import React, { useEffect, useState } from "react";
import "../../../assets/scss/home.scss";
import "../../../assets/scss/cources.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import CourseTable from "../../../components/tables/courseTable";
import PagePagination from "../../../components/tables/pagination";
import Repository from "../../../configs/axios/repository";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const Courses = (props) => {
    localStorage.setItem("canDoIt", false);
    const [loadingData, setLoadingData] = useState(false);
    const [courses, setCourses] = useState([]);
    const [showData, setShowData] = useState(10);
    const [skipData, setSkipData] = useState(0);
    const [count, setCount] = useState(null);
    const [showCources, setShowCources] = useState(true);
    const history = useHistory();
    const isInvateValue = useSelector((state) => state.layout.isInvate);
    const role = useSelector((state) => state.layout.role);

    const createCourses = async (values) => {
        history.push({
            pathname: "/createCourse",
        });
    };
    const findStudentCourses = async (skipTake) => {
        const result = await Repository.postRequest(
            `api/course/findStudentCourses`,
            skipTake
        );

        if (result.status === 200 || result.status === 201) {
            setCount(result.data.data.total);
            setCourses(
                result.data.data.courses?.map((val) => {
                    return {
                        course_id: val.course_id,
                        course_name: val.course_name,
                        description: val.description,
                        instructor_name: val.instructor_id.user_name,
                    };
                })
            );
        }
        setLoadingData(true);
    };

    const findCourse = async (skipTake) => {
       
        const result = await Repository.postRequest(
            `api/course/findAllCoursesInstructor`,
            skipTake
        );
        if (result.status === 200 || result.status === 201) {
            setCount(result.data.data.total);
            setCourses(
                result.data.data.courses?.map((val) => {
                    return {
                        course_id: val.course_id,
                        course_name: val.course_name,
                        description: val.description,
                    };
                })
            );
        }
        setLoadingData(true);
    };

    const refreshTable = () => {
        let skipTake = {
            skip: skipData,
            take: showData,
        };

        if (role == "instructor") {
       
            findCourse(skipTake);
        } else if (role == "student") {
           
            findStudentCourses(skipTake);
        }
    };

    useEffect(() => {
       
        refreshTable();
    }, [showData, skipData, role]);

    useEffect(() => {
        setShowCources(isInvateValue);
    }, [isInvateValue]);

    return loadingData ? (
        <div className="testBodyDiv homeSection">
            <div className="d-flex justify-content-between mb-2 px-2 courcesHead">
                <div className="childrenCourse testH1">
                    <div id="courseList" className="mt-3 ">
                        <h1>My Courses</h1>
                    </div>
                </div>
                {role == "instructor" ? (
                    <div id="createBtnDiv" className="courceCretaeParent">
                        <div className="createBtnDiv" onClick={createCourses}>
                            <span className="plus">+</span>
                            <span>NEW Course</span>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
            {courses?.length > 0 ? (
                <div className="mt-4">
                    <CourseTable
                        courses={courses}
                        refreshTable={refreshTable}
                        setLoadingData={setLoadingData}
                        loadingData={loadingData}
                        role={role}
                    />

                    <PagePagination
                        setShow={setShowData}
                        count={count}
                        setSkip={setSkipData}
                        skip={skipData}
                        show={showData}
                    />
                </div>
            ) : (
                <div>
                    <h5 className="nodata">No data created yet.</h5>
                </div>
            )}
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default Courses;
